<div class="select-player-dialog">
  <div class="flex flex-row justify-between items-center">
    <h1 mat-dialog-title>{{ 'components.dialogOtherPlayerSelect.title' | transloco }}</h1>
    <button mat-icon-button mat-dialog-close data-testid="closeSelectPlayer">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-button-toggle-group class="select-player flex flex-row flex-wrap" [hideSingleSelectionIndicator]="true">
    @for (player of data.players; track player) {
      <mat-button-toggle (click)="select(player)" [attr.data-testid]="'selectPlayer-' + player">
        {{ player }}
      </mat-button-toggle>
    }
  </mat-button-toggle-group>
</div>
